import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { ReactDatesStyleWrapper } from "./ReactDates.style";

class DateRangePickerBox extends Component {
  constructor(props) {
    super(props);
    const separator =
      this.props.item && this.props.item.separator
        ? this.props.item.separator
        : "/";
    const dateFormat =
      this.props.item && this.props.item.format
        ? this.props.item.format
        : "llll";
    this.state = {
      focusedInput: null,
      startDate: this.props.startDate ? this.props.startDate : null,
      endDate: this.props.endDate ? this.props.endDate : null,
      dateFormat,
      separator,
    };
    this.onDateChangeFunc = this.onDateChangeFunc.bind(this);
    this.onFocusChangeFunc = this.onFocusChangeFunc.bind(this);
  }

  onDateChangeFunc = ({ startDate, endDate }) => {
    const { dateFormat } = this.state;
    this.setState({ startDate, endDate });
    if (startDate !== null && endDate !== null) {
      // Format dates as "yyyy-mm-dd"
      const formattedStartDate = startDate.format("YYYY-MM-DD");
      const formattedEndDate = endDate.format("YYYY-MM-DD");
      this.props.updateSearchData({
        setStartDate: formattedStartDate,
        setEndDate: formattedEndDate,
      });
    }
  };

  onFocusChangeFunc = (focusedInput) => {
    return this.setState({ focusedInput });
  };

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const {
      className,
      startDateId,
      endDateId,
      disabled,
      showClearDates,
      isRTL,
      orientation,
      anchorDirection,
      withPortal,
      withFullScreenPortal,
      small,
      block,
      numberOfMonths,
      regular,
      noBorder,
      isDayBlocked,
    } = this.props;

    const addAllClasses = ["date_picker"];
    if (className) {
      addAllClasses.push(className);
    }

    const defaultCalenderProps = {
      startDateId: startDateId ? startDateId : "start_unique_id",
      endDateId: endDateId ? endDateId : "end_date_unique_id",
      startDate,
      endDate,
      focusedInput,
      onFocusChange: this.onFocusChangeFunc,
      onDatesChange: this.onDateChangeFunc,
      startDatePlaceholderText: "Check In", // Updated placeholder text
      endDatePlaceholderText: "Check Out", // Updated placeholder text
      disabled,
      isRTL,
      showClearDates: showClearDates ? showClearDates : false,
      orientation,
      anchorDirection,
      withPortal,
      withFullScreenPortal,
      small,
      numberOfMonths: numberOfMonths ? numberOfMonths : 2,
      block,
      regular,
      noBorder,
      displayFormat: "DD/MM/yyyy",
      isDayBlocked,
    };

    return (
      <ReactDatesStyleWrapper className={addAllClasses.join(" ")}>
        <DateRangePicker {...defaultCalenderProps} />
      </ReactDatesStyleWrapper>
    );
  }
}

DateRangePickerBox.propTypes = {
  startDateId: PropTypes.string.isRequired,
  endDateId: PropTypes.string.isRequired,
  disabled: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["START_DATE", "END_DATE"]),
  ]),
  showClearDates: PropTypes.bool,
  isRTL: PropTypes.bool,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  anchorDirection: PropTypes.oneOf(["left", "right"]),
  withPortal: PropTypes.bool,
  withFullScreenPortal: PropTypes.bool,
  small: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  block: PropTypes.bool,
  regular: PropTypes.bool,
  noBorder: PropTypes.bool,
  updateSearchData: PropTypes.func,
};

export default DateRangePickerBox;
